///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('#provider-email')) {
      document.querySelector('#provider-email').addEventListener('click', (e) => {
        const target = e.target;

        if (target.id == 'provider-email-edit-button') {
          const emailInput = new EmailInput(target);

          emailInput.toggleForm();
          emailInput.addCancelListener();
        }
      });
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Constructors
  //
  ///////////////////////////////////////////////////////////////////

  function EmailInput() {
    this.cancelButton      = document.querySelector('#provider-email-cancel-button');
    this.displayFormButton = document.querySelector('#provider-email-edit-button');
    this.emailForm         = document.querySelector('#provider-email-form');
    this.emailValue        = document.querySelector('#provider-email-value');
  }



  ///////////////////////////////////////////////////////////////////
  //
  // Prototype Definitions
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Toggle display of email form and
  //               edit form display button.
  //
  EmailInput.prototype.toggleForm = function() {
    if (this.emailForm.classList.contains('d-none') &&
        !this.displayFormButton.classList.contains('d-none')) {
      this.displayFormButton.classList.add('d-none');
      this.emailValue.classList.add('d-none');
      this.emailForm.classList.remove('d-none');
    } else {
      this.displayFormButton.classList.remove('d-none');
      this.emailValue.classList.remove('d-none');
      this.emailForm.classList.add('d-none');
    }
  };

  ///////////////////////////////////////////////
  //
  // Description - Adds click event listener to form's
  //               cancel button that hides review comment card
  //               and displays the edit form display button.
  //
  EmailInput.prototype.addCancelListener = function() {
    const emailInputObj = this;

    emailInputObj.cancelButton.addEventListener('click', function() {
      emailInputObj.toggleForm();
    });
  };
}());
